import React from 'react';
import classNames from 'classnames';
import useDarkMode from '../../../hooks/useDarkMode';
import Footer from '../../../layout/Footer/Footer';
import { useTranslation } from 'react-i18next';

const DefaultFooter = () => {
	const { darkModeStatus } = useDarkMode();
	const { t } = useTranslation();

	return (
		<Footer>
			<div className='container-fluid py-3'>
				<div className='row text-center text-md-start'>
					{/* Support email (mobile first on top, middle on desktop) */}
					<div className='col-12 col-md-6 order-1 order-md-2 mb-2 mb-md-0 text-center'>
						<small
							className={classNames('text-muted d-block', {
								'text-dark': !darkModeStatus,
								'text-light': darkModeStatus,
							})}>
							{t('For support or suggestions write an email to')}{' '}
							<a
								href={`mailto:${t('Support email')}`}
								className={classNames('text-decoration-none', {
									'link-primary': !darkModeStatus,
									'link-info': darkModeStatus,
								})}>
								{t('Support email')}
							</a>
						</small>
					</div>

					{/* Divider visible only on mobile */}
					<div className='col-12 order-2 d-md-none'>
						<hr className='my-2' />
					</div>

					{/* Copyright (left on desktop, bottom-left on mobile) */}
					<div className='col-6 col-md-3 order-3 order-md-1 text-start'>
						<span className='fw-light'>Copyright © 2025</span>
					</div>

					{/* OpenTalents (right on desktop, bottom-right on mobile) */}
					<div className='col-6 col-md-3 order-4 order-md-3 text-end'>
						<a
							href='/'
							className={classNames('text-decoration-none', {
								'link-dark': !darkModeStatus,
								'link-light': darkModeStatus,
							})}>
							<small className='fw-bold'>OpenTalents</small>
						</a>
					</div>
				</div>
			</div>
		</Footer>
	);
};

export default DefaultFooter;
